export default "__VITE_ASSET__84a77ebd__"